import { motion } from "framer-motion";
import Reveal from "@/components/Reveal";

const SHOTS = [
  {
    src: "/img/shot-leave-time.webp",
    alt: "Tripsee app overview showing a recommended leave time of 4:06 AM to arrive at the gate 30 minutes early",
    caption: "Your leave time, to the minute",
  },
  {
    src: "/img/shot-timeline-live.webp",
    alt: "Tripsee live timeline tracking each step from transportation to TSA screening",
    caption: "A timeline that tracks you live",
  },
  {
    src: "/img/shot-timeline-behind.webp",
    alt: "Tripsee timeline warning the traveler is running 17 minutes behind schedule",
    caption: "Running behind? It tells you",
  },
  {
    src: "/img/shot-flight-ratings.webp",
    alt: "Tripsee flight reliability ratings showing on-time percentage, average delay, and cancellation rate",
    caption: "Every flight, rated for reliability",
  },
];

export default function AppShowcase() {
  return (
    <section className="relative py-28 sm:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="max-w-3xl">
          <p className="font-mono text-xs tracking-[0.3em] text-primary uppercase mb-5">App Preview</p>
          <h2 className="font-display text-2xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-tight text-white">
            Straight from the app.
          </h2>
          <p className="mt-5 text-lg text-slate-400 leading-relaxed">
            Real screens from Tripsee: leave times, live timelines, and flight reliability,
            exactly as you'll see them on travel day.
          </p>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-6">
          {SHOTS.map((s, i) => (
            <motion.figure
              key={s.src}
              data-testid={`app-showcase-shot-${i}`}
              initial={{ opacity: 0, y: 44, rotate: i % 2 === 0 ? -2.5 : 2.5 }}
              whileInView={{ opacity: 1, y: 0, rotate: i % 2 === 0 ? -1.5 : 1.5 }}
              whileHover={{ rotate: 0, scale: 1.03 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className="group"
            >
              <div className="rounded-[2.2rem] border border-white/10 bg-[#15181C] p-2 shadow-2xl shadow-black/60 transition-colors duration-300 group-hover:border-primary/40">
                <div className="overflow-hidden rounded-[1.8rem]">
                  <img
                    src={s.src}
                    alt={s.alt}
                    loading="lazy"
                    className="w-full h-auto block"
                  />
                </div>
              </div>
              <figcaption className="mt-4 text-center">
                <span className="text-sm font-medium text-slate-300">{s.caption}</span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
